import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { fm } from '../../utils';

const COLORS = ['#10b981', '#3b82f6', '#f59e0b', '#8b5cf6', '#f43f5e', '#06b6d4', '#84cc16'];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white dark:bg-surface-800 border border-surface-200 dark:border-surface-700 rounded-xl shadow-lg p-3 text-xs">
      <p className="font-semibold text-surface-700 dark:text-surface-300 mb-1">{d.name}</p>
      <p className="text-surface-500">Tutar: <span className="font-semibold">{fm(d.value)}</span></p>
      <p className="text-surface-500">Yüzde: <span className="font-semibold">%{d.yuzde}</span></p>
      <p className="text-surface-500">Adet: <span className="font-semibold">{d.adet}</span></p>
    </div>
  );
};

const PaymentChart = ({ data = [] }) => {
  const total = data.reduce((t, d) => t + d.value, 0);
  return (
    <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
      <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">Ödeme Dağılımı</h4>
      {data.length === 0 ? (
        <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
      ) : (
        <div className="flex items-center gap-4">
          <div className="h-48 w-48 flex-shrink-0">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={data} cx="50%" cy="50%" innerRadius={55} outerRadius={80} dataKey="value" nameKey="name" paddingAngle={3}>
                  {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex-1 space-y-1.5">
            {data.map((d, i) => (
              <div key={i} className="flex items-center justify-between text-xs">
                <div className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
                  <span className="text-surface-600 dark:text-surface-400">{d.name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-semibold text-surface-700 dark:text-surface-300">%{d.yuzde}</span>
                  <span className="text-surface-400 min-w-[90px] text-right">{fm(d.value)}</span>
                </div>
              </div>
            ))}
            <div className="border-t border-surface-100 dark:border-surface-700 pt-1.5 mt-1.5 flex justify-between text-xs font-semibold text-surface-700 dark:text-surface-300">
              <span>Toplam</span>
              <span>{fm(total)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentChart;
